
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"1"}},[_c('path',{attrs:{"d":"M356.65 450H171.47a41 41 0 01-40.9-40.9V120.66a15 15 0 0115-15h237a15 15 0 0115 15V409.1a41 41 0 01-40.92 40.9zM160.57 135.66V409.1a10.91 10.91 0 0010.9 10.9h185.18a10.91 10.91 0 0010.91-10.9V135.66z"}}),_c('path',{attrs:{"d":"M327.06 135.66h-126a15 15 0 01-15-15V93.4a44.79 44.79 0 0144.74-44.73h66.52a44.79 44.79 0 0144.74 44.73v27.26a15 15 0 01-15 15zm-111-30h96V93.4a14.75 14.75 0 00-14.74-14.73H230.8a14.75 14.75 0 00-14.73 14.73zM264.06 392.58a15 15 0 01-15-15V178.09a15 15 0 1130 0v199.49a15 15 0 01-15 15zM209.9 392.58a15 15 0 01-15-15V178.09a15 15 0 0130 0v199.49a15 15 0 01-15 15zM318.23 392.58a15 15 0 01-15-15V178.09a15 15 0 0130 0v199.49a15 15 0 01-15 15z"}}),_c('path',{attrs:{"d":"M405.81 135.66H122.32a15 15 0 010-30h283.49a15 15 0 010 30z"}})])])
          )
        }
      }
    